<div id="about" class="profile-box info-box">
  <header class="accent">
    <div i18n class="title">Общее</div>
  </header>

  <div class="content">
    <!-- TODO: Дописать вывод ошибок для полей -->
    <form
      (ngSubmit)="onSubmitPhysicalClientEditForm()"
      [formGroup]="physicalClientEditForm"
      novalidate
      class="flex flex-col">
      <mat-form-field appearance="outline">
        <mat-label i18n>Email</mat-label>
        <input matInput disabled [value]="about.email" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Фамилия</mat-label>
        <input type="text" matInput formControlName="surname" autofocus />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Имя</mat-label>
        <input type="text" matInput formControlName="name" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Отчество</mat-label>
        <input type="text" matInput formControlName="patronymic" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Название компании</mat-label>
        <input type="text" matInput formControlName="companyName" />
      </mat-form-field>

      <mat-form-field appearance="outline" [class.hidden]="about.type !== clientType.JuridicalPerson">
        <mat-label i18n>ИНН</mat-label>
        <input type="text" matInput formControlName="inn" [required]="requiredINN ? true : null" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Телефон</mat-label>
        <input type="tel" matInput formControlName="phone" [required]="usePhoneNumber ? true : null" />
        <span matPrefix>+</span>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Адрес доставки по умолчанию</mat-label>
        <input
          (blur)="addressAutocompleteClosed()"
          type="text"
          matInput
          formControlName="defaultDeliveryAddress"
          [matAutocomplete]="auto" />
        <mat-autocomplete
          autoActiveFirstOption
          #auto="matAutocomplete"
          [displayWith]="addressAutocompleteDisplayFn"
          (closed)="addressAutocompleteClosed()">
          <mat-option *ngFor="let option of addressResponse$ | async" [value]="option">
            {{ addressAutocompleteDisplayFn(option) }}
          </mat-option>
        </mat-autocomplete>

        <mat-error i18n *ngIf="physicalClientEditForm.get('defaultDeliveryAddress').hasError('required')"
          >Поле не должно быть пустым</mat-error
        >
      </mat-form-field>

      <div class="mb-4 flex justify-center items-center gap-3">
        <div class="flex flex-col flex-grow">
          <div i18n class="mat-caption m-0">Персональный менеджер</div>
          <div *ngIf="about.personalManagerId" class="text-truncate mat-subheading-2 m-0">
            {{ about.personalManagerFullName }}
          </div>
          <div i18n *ngIf="!about.personalManagerId" class="text-truncate mat-subheading-2 m-0">Не задан</div>
        </div>
        <div *ngIf="allowClientsChooseManager">
          <button
            type="button"
            i18n-matTooltip
            mat-icon-button
            matTooltip="Изменить"
            (click)="openAppointManagerDialog()">
            <mat-icon>settings</mat-icon>
          </button>
          <button type="button" i18n-matTooltip mat-icon-button matTooltip="Удалить" (click)="removePersonalManager()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>

      <button
        i18n
        mat-raised-button
        type="submit"
        color="accent"
        [disabled]="physicalClientEditForm.invalid"
        class="mx-16"
        >Сохранить</button
      >
    </form>
  </div>
</div>
